import { type ReactNode } from "react";
import Header from "./Header";
import PageHeader from "./PageHeader";
import Container from "./Container";

interface RootLayoutProps {
  children: ReactNode;
  title: string;
  subtitle?: string | undefined;
}

const RootLayout = ({ children, title, subtitle }: RootLayoutProps) => (
  <div className="min-h-full">
    <Header />
    <PageHeader title={title} subtitle={subtitle} />
    <Container>{children}</Container>
  </div>
);

export default RootLayout;
